<!-- eslint-disable -->
<template>

  <div class="card bg-white border-0 rounded-3 mb-4 shadow-sm">
    <div class="card-body p-0">

      <div
          class="d-flex justify-content-between align-items-center flex-wrap gap-3 p-4">
        <!-- Navigation Links -->

        <!-- Filters and Add Candidate -->
        <div class="d-flex align-items-right gap-3">


          <!-- Add Candidate Button -->
          <a
              href="/legal/create"
              class="btn btn-outline-primary py-2 px-3 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
          >
            <i class="ri-add-line d-none d-sm-inline-block"></i>
            <span>Добавить документ</span>
          </a>
        </div>
      </div>

      <!-- Custom Alert -->
      <div v-if="deleteAlert.visible" class="custom-alert">
        <div class="alert-content">
          <p class="alert-message">Подтвердите удаление</p>
          <div class="alert-buttons">
            <button
                type="button"
                class="btn btn-danger confirm-button"
                @click="confirmDelete"
            >
              Подтвердить
            </button>
            <button
                type="button"
                class="btn btn-secondary cancel-button"
                @click="cancelDelete"
            >
              Отменить
            </button>
          </div>
        </div>
      </div>

      <div v-if="infoAlert.visible" class="info-alert">
        <div class="alert-content">
          <p class="alert-message">Открыть Viber</p>
          <div class="alert-buttons">
            <button
                type="button"
                class="btn btn-primary confirm-button-"
                @click="confirmOpenViber"
            >
              Подтвердить
            </button> &nbsp;
            <button
                type="button"
                class="btn btn-secondary cancel-button"
                @click="cancelOpenViber"
            >
              Отменить
            </button>
          </div>
        </div>
      </div>


      <div class="default-table-area style-two all-projects">
        <div class="table-responsive">
          <table class="table table-bordered table-striped- table-hover align-middle">
            <thead class="table-light">
            <tr>
              <th style="width: 10px;">#</th>
              <th v-for="(field, index) in fields" :key="field.name" scope="col" style="width: 70px;"
                  :class="getWidthColumn(field.name)">
                <div v-if="field.showAsMain">
                  <div @click="handleSortClick(field.name)"
                       class="cursor-pointer d-flex justify-content-between align-items-center">
                    {{ field.label }}
                    <span class="material-symbols-outlined"> {{ getSortIcon(field.name) }} </span>
                  </div>
                </div>
              </th>
              <th scope="col" class="actions-column">Действия</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, index) in list" :key="row.id">
              <td>{{ list.length - index }}</td>
              <td v-for="field in fields" :key="field.name">

                <div class="clickable-column" v-if="field.showAsMain">
                  <div v-if="field.name==='name'">
                    {{ row.name }}
                  </div>

                  <div v-else-if="field.name==='signatureLink'">

                    <a :href="'https://viaglobal.pl/api//sign/' + row.signatureLink"
                       target="_blank"
                       class="text-blue-500 hover:underline"
                    >Ссылка</a>

                  </div>


                  <div v-else-if="field.name==='gender'">
                              <span> {{
                                  row.gender === 1 ? 'М' : (row.gender === 2 ? 'Ж' : (row.gender === 3 ? 'П' : ''))
                                }}</span>
                  </div>
                  <div v-else-if="field.name==='vacancy_number'">
                    {{ row.number }}
                  </div>
                  <div v-else-if="field.name === 'phone'">

                    <a :href="'viber://chat?number=' + encodeURIComponent(row.phone)">
                      {{ row.phone }}
                    </a>
                    <!--                      <a @click="showViberConfirmation(row)">{{ row.phone }}</a>-->
                  </div>
                  <div v-else-if="field.name==='vacancy_title'">
                    {{ row.project }}
                    <!--             <router-link to="/vacancies/index/status1">
                                   <span class="link-type"> {{ row.vacancy.title }} </span>
                                 </router-link>-->
                  </div>
                  <div v-else-if="field.name==='arrivalDate'">
                    {{ formatDate(row.arrivalDate) }}
                  </div>
                  <div
                      v-else-if="field.name==='recruiter' && (userRole==='grand_admin' || userRole==='manager' ) ">
                    {{ row.recruiter }}
                  </div>
                  <div v-else-if="field.name==='coordinator'">
                    {{ row.coordinator }}
                  </div>
                  <div v-else-if="field.name==='created_at'">
                    {{ row.createdAt }}
                  </div>
                  <div v-else-if="field.name==='status'">
                            <span
                                :class="[
    row.status === 'Работает' ? 'badge bg-success bg-opacity-10 text-success' :
    row.status === 'Не работает' ? 'badge bg-danger bg-opacity-10 text-danger' :
    'badge bg-secondary bg-opacity-10 text-primary',
    'p-2 fs-12 fw-normal'
  ]"
                            >
  {{ row.status }} <br/>

</span>
                  </div>
                  <div v-else>
                    {{ row[field.name] }}
                  </div>
                  <!--                            <div v-else-if="field.name === 'city'">
                                                <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                                                  {{ row.vacancyCandidates[0].city }}
                                                </div>
                                              </div>
                                              <div v-else-if="field.name === 'position'">
                                                <div v-for="(position, key) in row.vacancyCandidates" :key="key">
                                                  <div v-if="userRole==='coordinator_su' || userRole==='coordinator_zl'">
                                                    <div v-if="position.is_active === 1">
                                                      <b>{{ position.position }} </b><br/> ({{ position.rate }} zl.) <br/>
                                                      <b> М:</b>{{ position.quantity1 > 0 ? position.quantity1 : 0 }}
                                                      <b> Ж:</b>{{ position.quantity2 > 0 ? position.quantity2 : 0 }}
                                                      <b> П:</b>{{ position.quantity3 > 0 ? position.quantity3 : 0 }}
                                                    </div>
                                                  </div>
                                                  <div v-else>
                                                    <b>{{ position.position }} </b><br/> ({{ position.rate }} zl.) <br/>
                                                    <b> М:</b>{{ position.quantity1 > 0 ? position.quantity1 : 0 }}
                                                    <b> Ж:</b>{{ position.quantity2 > 0 ? position.quantity2 : 0 }}
                                                    <b> П:</b>{{ position.quantity3 > 0 ? position.quantity3 : 0 }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-else-if="field.name === 'livingExists'">
                                                <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                                                  <div v-if="row.vacancyCandidates[0].livingExists == 0">нет</div>
                                                  <div v-if="row.vacancyCandidates[0].livingExists == 1">
                                                    {{ row.vacancyCandidates[0].livingPrice }}
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-else-if="field.name === 'nation'"
                                                   class="clickable-column">
                                                <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                                                <span v-for="country in JSON.parse(row.vacancyCandidates[0].nation)" :key="country">
                                                  <img :src="`/images/flags/${country.slice(0, 3)}.svg`" :alt="country" width="24"
                                                       height="16"> &nbsp;
                                                </span>
                                                </div>
                                              </div>
                                              <div v-else-if="field.name === 'isArrival'"
                                                   class="clickable-column">
                                                <div v-if="row.vacancyCandidates && row.vacancyCandidates[0]">
                                                  <span>  {{ row.vacancyCandidates[0].isArrival == '1' ? '' : 'Нет' }}</span>
                                                  <span v-if="row.vacancyCandidates[0].isArrival == '1'">   {{
                                                      row.vacancyCandidates[0].arrivalAddress
                                                    }} </span> <br/>
                                                  <span v-if="row.vacancyCandidates[0].isArrival == '1'">   {{
                                                      row.vacancyCandidates[0].arrivalPrice
                                                    }} zl </span>
                                                </div>
                                              </div>
                                              <div v-else>{{ row[field.name] }}</div>-->
                </div>
              </td>
              <td class="actions-column">

                <button @click="download(row.emptyDocument)"
                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                >
                  <i class="material-symbols-outlined fs-16 text-info" title="Скачать документ">description</i>
                </button>

                <button v-if="row.signedDocument" @click="download(row.signedDocument)"
                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                >
                  <i class="material-symbols-outlined fs-16 text-success" title="Скачать подписанный документ">description</i>
                </button>

                <button v-if="row.signedDocument"
                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                        @click="handleEdit(row.id)"
                >
                  <i class="material-symbols-outlined fs-16 text-primary" title="Редактировать">edit</i>
                </button>

                <button
                    class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                    @click="showDeleteConfirmation(row)"
                >
                  <i class="material-symbols-outlined fs-16 text-primary" title="Удалить">delete</i>
                </button>

                <button v-if="listQuery.isActive===1"
                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                        @click="handleActivate(row)"
                >
                  <i class="material-symbols-outlined fs-16 text-warning" title="Деактивировать">lock</i>
                </button>

                <button v-if="listQuery.isActive===0"
                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                        @click="handleActivate(row)"
                >
                  <i class="material-symbols-outlined fs-16 text-success" title="Активировать">lock</i>
                </button>

                <!--                <button @click="download(row.signedDocument)"
                                        class="ps-0 border-0 bg-transparent lh-1 position-relative top-2"
                                >
                                  <i class="material-symbols-outlined fs-16 text-success" title="Скачать подписанный документ">description</i>
                                </button>-->
                <!--                  &lt;!&ndash; Signed Document (similar to empty) &ndash;&gt;
                                  <button
                                      class="btn btn-outline-secondary"
                                      @click="download(row.signedDocument)"
                                      title="Signed Document"
                                  >
                                    <span class="material-icons-outlined">description</span> Подписанный документ
                                  </button>
                                  <br/>

                                  <a
                                      v-if="temp.sign_image_url"
                                      :href="temp.sign_image_url"
                                      target="_blank"
                                      class="btn btn-outline-primary"
                                      title="Сравнить подписи"
                                  >
                                    <span class="material-icons-outlined">image</span> Сравнить подписи
                                  </a>


                                  &lt;!&ndash; Edit &ndash;&gt;
                                  <button
                                      class="btn btn-outline-primary"
                                      @click="handleEdit"
                                      title="Edit"
                                  >
                                    <span class="material-icons-outlined">edit</span> Edit
                                  </button>

                                  &lt;!&ndash; Delete &ndash;&gt;
                                  <button
                                      class="btn btn-outline-danger"
                                      @click="handleDelete"
                                      title="Delete"
                                  >
                                    <span class="material-icons-outlined">delete</span> Удалить
                                  </button>

                                  &lt;!&ndash; Make Inactive &ndash;&gt;
                                  <button
                                      v-if="temp.is_active"
                                      class="btn btn-outline-warning"
                                      @click="handleMakeInactive"
                                      title="Make Inactive"
                                  >
                                    <span class="material-icons-outlined">visibility_off</span> Деактивировать
                                  </button>
                                  <button
                                      v-else
                                      class="btn btn-outline-success"
                                      @click="handleMakeActive"
                                      title="Make Active"
                                  >
                                    <span class="material-icons-outlined">visibility</span> Активировать
                                  </button>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>


    </div>
  </div>

</template>

<script>
import {fetchList, createLegal, updateLegal, deleteLegal, activateLegal} from '@/api/legal';
import {parseTime} from '@/utils';
import {defineComponent, ref, watchEffect, nextTick} from "vue";

const calendarTypeOptions = [
  {key: 'US', display_name: 'USA'},
];

const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});

export default {
  name: 'candidatesTable',
  components: {},
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger',
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    return {
      years: [
        2024,
        2025,
      ],
      deleteAlert: {
        visible: false,
        row: null,
      },
      infoAlert: {
        visible: false,
        row: null,
      },
      isOpen: false,
      isOpen2: false,
      vacancyDetail: null,
      isOffcanvasVisible: false,
      fromVacancy: false,
      peselOption: 'no',
      peselOption2: 'no',
      userRole: '',
      position: null,
      tableKey: 0,
      vacancies: [],
      recruiters: [],
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        isActive: 1,
        search: '',
        sort: '+id',
        status: 1,
        //year: new Date(),
        year: 2025,
        month: new Date().getMonth() + 1
        /*     year: 2025,
             month: 1,*/
      },
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      calendarTypeOptions,
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      formattedVacancies: [],
      temp: {
        name: '',
        vacancyCandidateId: null,
        is_pair: 0,
        pesel: '',
        recruiterId: '',
        birth: ''
      },
      temp2: {
        name: '',
        vacancyCandidateId: null,
        gender: 3,
        is_pair: 1,
        pesel: '',
        recruiterId: '',
        birth: ''
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogBlackListVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create',
      },
      dialogPvVisible: false,
      pvData: [],
      fields: [
        {label: 'Имя', name: 'name', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Фамилия', name: 'surname', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Фирма', name: 'company', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Проект', name: 'project', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Должность', name: 'position', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Ставка', name: 'rate', showAsMain: true, showForArrival: true, showForRetired: true},

        {label: 'Телефон', name: 'phone', showAsMain: true, showForArrival: true, showForRetired: true},

        {label: 'Email', name: 'email', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Ссылка', name: 'signatureLink', showAsMain: true, showForArrival: true, showForRetired: true},
        /*       {label: 'Дата рождения', name: 'birth', showAsMain: true, showForArrival: true, showForRetired: true},*/
      ],

      fieldsStatus1: [
        {label: '№', name: 'vacancy_number', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Проект', name: 'vacancy_title', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Кандидат', name: 'name', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Номер телефона', name: 'phone', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Дата приезда', name: 'arrivalDate', showAsMain: true, showForArrival: false, showForRetired: false},
        {label: 'Рекрутер', name: 'recruiter', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Координатор', name: 'coordinator', showAsMain: true, showForArrival: true, showForRetired: true}
      ],

      fieldsStatus4: [
        {label: '№', name: 'vacancy_number', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Проект', name: 'vacancy_title', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Кандидат', name: 'name', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Номер телефона', name: 'phone', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Статус', name: 'status', showAsMain: true, showForArrival: false, showForRetired: false},
        {label: 'Дата', name: 'arrivalDate', showAsMain: true, showForArrival: false, showForRetired: false},
        {label: 'Рекрутер', name: 'recruiter', showAsMain: true, showForArrival: true, showForRetired: true},
        {label: 'Координатор', name: 'coordinator', showAsMain: true, showForArrival: true, showForRetired: true}
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  beforeDestroy() {
    this.stopStoragePolling(); // Clean up polling interval
  },
  created: async function () {
    this.parseStatusFromUrl();
    this.loadSearchTerm(); // Load initial search term
    //this.startStoragePolling(); // Start polling local storage
    this.getList(this.listQuery);
  },
  methods: {
    async download(url) {
      let url1 = 'https://viaglobal.pl/api//download-contract/' + url;
      axios.get(url1, {
        responseType: 'blob'
      }).then(downloadResponse => {
        const blob = new Blob([downloadResponse.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = url1.split('/').pop();
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
      });


      // let filePath = 'https://viaglobal.pl/api//download-pdf/'+url;
      // try {
      //   // Construct full URL to your Laravel public folder
      //   const fullUrl = filePath;
      //
      //   alert(filePath);
      //
      //   // Create temporary link
      //   const link = document.createElement('a');
      //   link.href = fullUrl;
      //   link.target = '_blank';
      //
      //   // Extract filename from path
      //   const filename = filePath.split('/').pop();
      //   link.download = filename || 'document.pdf';
      //
      //   // Trigger download
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //
      //   // Fallback for mobile devices if needed
      //   window.open(fullUrl, '_blank');
      // } catch (error) {
      //   console.error('Download failed:', error);
      //   alert('Failed to download document');
      // }
    },
    getWidthColumn(name) {
      console.log(name);
      if (name === 'vacancy_number') return 'width70';
      if (name === 'status') return 'width100';
      if (name === 'price') return 'width100';
      return '';
    },
    loadSearchTerm() {
      this.listQuery.search = localStorage.getItem("searchTerm") || ""; // Load from local storage
      console.log(this.listQuery.search);
    },
    handleStorageChange(event) {
      if (event.key === "searchTerm") {
        this.searchTerm = event.newValue; // Update search term when local storage changes
        this.getList();
      }
    },
    startStoragePolling() {
      // Poll local storage for changes every 500ms
      this.storagePollingInterval = setInterval(() => {
        const currentSearchTerm = localStorage.getItem("searchTerm") || "";
        if (currentSearchTerm !== this.listQuery.search) {
          this.listQuery.search = currentSearchTerm; // Update search term
          this.getList(); // Perform search
        }
      }, 500);
    },
    stopStoragePolling() {
      // Clear the polling interval
      if (this.storagePollingInterval) {
        clearInterval(this.storagePollingInterval);
      }
    },
    menuItemToggle() {
      this.isOpen = !this.isOpen; // Toggles the `open` class
    },
    menuItemToggle2() {
      this.isOpen2 = !this.isOpen2; // Toggles the `open` class
    },
    closeOffcanvas() {
      this.isOffcanvasVisible = false;  // Close the offcanvas
    },
    handleRightClick(event) {
      event.preventDefault(); // Disable the default context menu

      // Get the cell data
      const cellData = event.target.innerText;

      // Call your method with cell data
      this.openCustomContextMenu(cellData, event);

      // Add an event listener to the document to reset filters on click outside
      document.addEventListener('click', this.handleDocumentClick);
    },
    openCustomContextMenu(cellData, event) {
      // Your custom context menu logic
      console.log('Right-clicked cell data:', cellData);
      this.listQuery.search = cellData;
      this.handleFilter();
    },
    handleDocumentClick(event) {
      const tableElement = this.$refs.candidates1.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement && !tableElement.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement2 = this.$refs.candidates2.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement2 && !tableElement2.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }

      const tableElement3 = this.$refs.candidates3.$el; // Access the DOM element of the table
      // Check if the click was outside the table
      if (tableElement3 && !tableElement3.contains(event.target)) {
        this.resetFilters();
        document.removeEventListener('click', this.handleDocumentClick);
      }
    },
    resetFilters() {
      this.listQuery.search = '';
      this.handleFilter();
      // Your logic to reset filters
      console.log('Filters reset');
    },
    arrivalLabel() {
      return 'Работает от';
      // return this.listQuery.status === 3 ? 'Работает от' : 'Дата приезда';
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      if (path === '/legal/inactive') {
        this.listQuery.isActive = 0;
      } else {
        this.listQuery.isActive = 1;
      }
    },
    setRules() {
      return {
        name: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        phone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        passport: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        /*  pesel: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],*/
        comment: [{required: false, message: 'Обязательное поле', trigger: 'blur'}],
        gender: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      this.listLoading = true;
      const data = await fetchList(this.listQuery);
      this.list = data.legals.items;
      this.total = data.legals.total;
      this.userRole = data.userRole;
      this.listLoading = false;
    },
    formatVacancies(data) {
      let options = [];
      this.vacancies.forEach(vacancy => {
        if (vacancy.is_active === 1) {
          vacancy.vacancy_candidates.forEach(candidate => {
            options.push({
              label: `${vacancy.title}/${candidate.position}`,
              value: candidate.id
            });
          });
        }
      });
      this.formattedVacancies = options;
    },
    handleFilter() {
      //alert(this.listQuery.year);
      const searchQuery = this.listQuery.search?.trim(); // Ensure search is trimmed and exists

      if (!searchQuery) {  // If searchQuery is null, undefined, or empty, reset the filter
        this.listQuery.search = '';
        this.listQuery.page = 1;
        this.getList();  // Return full list
      } else if (searchQuery.length === 1) {
        // Do nothing if length is 1
        return;
      } else if (searchQuery.length > 1) {  // If length > 1, search and save
        this.listQuery.page = 1;
        this.getList();
      }
    },
    handleFilterStatus(status) {
      this.listQuery.status = status;
      this.getList();
    },
    handleModifyStatus(row, status) {
      this.$message({
        message: 'Successful operation',
        type: 'success',
      });
      row.status = status;
    },
    handleSortClick(field) {
      if (field === 'rate' || field === 'quantity') return;
      this.sortChange(field);
    },
    sortChange(field) {
      if (this.listQuery.sort === '+' + field) {
        this.listQuery.sort = '-' + field; // Toggle to descending
      } else {
        this.listQuery.sort = '+' + field; // Toggle to ascending
      }
      this.handleFilter();
    },
    getSortIcon(field) {
      if (this.listQuery.sort === '+' + field) {
        return "arrow_drop_up"; // Ascending icon
      } else if (this.listQuery.sort === '-' + field) {
        return "arrow_drop_down"; // Descending icon
      }
      //return "unfold_more"; // Default (no sorting applied)
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate(fromVacancy = false) {
      if (!fromVacancy) {
        this.resetTemp();
      }
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleExport() {

    },
    handleBlackList() {
      this.dialogBlackListVisible = true;
    },
    createData() {
      if (this.temp.status === 'Приезд' && !this.temp.arrivalDate) {
        alert('Введите дату приезда');
        return
      }
      if (this.peselOption === 'yes' && this.temp.pesel === '') {
        alert('Введите pesel');
        return
      }
      if (this.peselOption2 === 'yes' && this.temp.pesel2 === '') {
        alert('Введите pesel для пары');
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createCandidate(this.temp).then((response) => {
            if (response.redirect) {
              this.$router.push('/black-list/index');
            } else if (this.temp.gender === 3 && this.temp2.name !== '') {
              createCandidate(this.temp2).then(() => {
                console.log('Pair created');
              });
            } else if (this.fromVacancy) {
              this.$router.push('/candidates/status1');
            } else {
              window.location.reload();
            }

            this.list.unshift(this.temp);
            this.dialogFormVisible = false;
            window.location.reload();
            /*      this.$notify({
                    title: 'Успешно',
                    message: 'Успешно',
                    type: 'success',
                    duration: 2000,
                  });*/
          });
        }
      });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          updateCandidate(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            /*     this.$notify({
                   title: 'Успешно',
                   message: 'Данные успешно изменены',
                   type: 'success',
                   duration: 2000,
                 });*/
            let redirect = '1';
            if (this.temp.status === 'Работает') {
              redirect = '3';
            } else if (this.temp.status === 'Не работает') {
              redirect = '4';
            }
            window.location.href = '/candidates/status' + redirect;
          });
        }
      });
    },
    showDeleteConfirmation(row) {
      this.deleteAlert.row = row;
      this.deleteAlert.visible = true;

      this.$nextTick(() => {
        const alertElement = document.querySelector(".custom-alert");
        if (alertElement) {
          alertElement.scrollIntoView({behavior: "smooth", block: "center"});
        }
      });

    },
    showViberConfirmation(row) {
      this.infoAlert.row = row;
      this.infoAlert.visible = true;
    },
    confirmOpenViber(phone) {
      window.location.href = 'viber://chat?number=%2B' + phone;
    },
    cancelOpenViber() {
      this.infoAlert.visible = false;
      this.infoAlert.row = null;
    },
    confirmDelete() {
      const row = this.deleteAlert.row;
      if (row) {
        deleteLegal(row).then(() => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
          this.cancelDelete();
        });
      }
    },
    cancelDelete() {
      this.deleteAlert.visible = false;
      this.deleteAlert.row = null;
    },
    handleActivate(row) {
      activateLegal(row.id).then(() => {
        alert('Статус изменен');
        window.location.reload();
      });
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.temp.image = e.target.result;
      };
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    handleDownload() {
      /*  this.downloadLoading = true;
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['№', 'Вакансия', 'Цена', 'Статус', 'Дата', 'Кандидат', 'Телефон', 'Рекрутер', 'Координатор', 'Комментарий'];
          const filterVal = ['number', 'project', 'rate', 'status', 'arrivalDate', 'name', 'phone', 'coordinator', 'recruiter', ''];
          const list = this.list;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'candidates',
            autoWidth: this.autoWidth,
            bookType: this.bookType,
          });
          this.downloadLoading = false;
        });*/
    },
  },
  computed: {},
  watch: {
    '$route'(to, from) {
      this.parseStatusFromUrl();
      this.getList(this.listQuery);
    }
  }
};
</script>

<style lang="scss" scoped>
/* Make header clickable */
.sortable-header {
  cursor: pointer;
}

/* Hover effect */
.sortable-header:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Sort icon styles */
.sort-icon {
  font-size: 20px;
  margin-left: 8px;
}

.custom-alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  width: 100%;
}

.alert-content {
  text-align: center;
}

.alert-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

/* Table styles */
.default-table-area {
  width: 100%;
  overflow-x: auto; // Allow horizontal scrolling if necessary

  .table-responsive {
    width: 100%;
    overflow-x: auto; // Ensure the table is scrollable horizontally

    .table {
      width: 100%;
      table-layout: fixed; // Ensure the table layout is fixed

      th,
      td {
        white-space: nowrap; // Prevent text from wrapping
        overflow: hidden; // Hide overflow
        text-overflow: ellipsis; // Add ellipsis for overflow text
      }

      .actions-column {
        width: 120px; // Fixed width for actions column
        /*    text-align: center; // Center align the buttons*/
      }

      tbody {
        tr {
          td {
            ul {
              li {
                &.ms-m-15 {
                  &:first-child {
                    margin-left: 0;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.max-width-column {
  max-width: 10px; // Set your desired maximum width
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Additional styles for clickable columns */
.clickable-column {
  cursor: pointer;
}

.clickable-column:hover {
  background: rgba(0, 0, 0, 0.05);
}

/* Ensure buttons are always visible */
.actions-column {
  button {
    margin: 0 5px; // Add spacing between buttons
    padding: 5px 10px; // Add padding for better clickability
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
  }

  button:hover {
    opacity: 0.9;
  }
}

label.el-form-item__label {
  text-align: left !important;
}

.flex-container {
  display: flex;
}

.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}

.image-upload-section {
  position: relative;
  left: 100px
}

.form-input {
  width: 100%;
}

.flex-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto; /* Allows horizontal scrolling on small screens */
  white-space: nowrap; /* Prevents text from wrapping */
}

.filter-item {
  margin-right: 10px; /* Adjust spacing as needed */
}

@media (max-width: 768px) {
  .flex-container {
    justify-content: flex-start; /* Align items to the start on smaller screens */
  }
}

.filter-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-item {
  margin: 5px 0;
}

.filter-item--full-width {
  width: 200px;
}

.filter-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.filter-label {
  font-weight: bold;
}

.filter-actions {
  margin-top: 10px;
  display: flex;
  gap: 10px;
}

.table-container {
  overflow-x: auto;
}

.data-table {
  min-width: 800px;
}

@media (max-width: 768px) {
  .filter-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .filter-item--full-width {
    width: 100%;
  }

  .data-table {
    min-width: 600px;
  }
}

.vacancy-number {
  max-width: 30px; /* Set the maximum width as needed */
  display: inline-block; /* Allows width restrictions to apply to the span */
  overflow: visible; /* Hide the overflow content */
  text-overflow: ellipsis; /* Show ellipsis (...) when content is too long */
  white-space: nowrap; /* Prevents text from wrapping to the next line */
}

.info-alert {
  background-color: #ecf0ff;
  border: 1px solid #ecf0ff;
  border-radius: 5px;
  padding: 20px;
  margin: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.custom-alert {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1050;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 400px;
  width: 100%;
}

.alert-content {
  text-align: center;
}

.alert-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.confirm-button {
  background-color: #dc3545;
  color: white;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
}

.width10 {
  width: 10px;
}

.width70 {
  width: 70px;
}

.width100 {
  width: 100px;
}
</style>
<!-- eslint-enable -->
